module.exports = __webpack_public_path__ + "img/FrameTou.5b41cfcc.png";